module.exports = __webpack_public_path__ + "static/1a53cc34.woo.png";